import { DECISION_TRACKS, DecisionTrack } from "@/constants/decision-track";

import { BATCH_TRACK_LABELS } from "./messages";

export interface TrackSpec {
  readonly sectionTitle: string;
  readonly sectionHint: string;
  readonly summaryOf: (count: number) => string;
  readonly requiresIdentity: boolean;
  readonly requiresInstallments: boolean;
}

export const TRACK_SPEC: Record<DecisionTrack, TrackSpec> = {
  [DECISION_TRACKS.PAYROLL_DISCOUNT]: {
    sectionTitle:
      BATCH_TRACK_LABELS[DECISION_TRACKS.PAYROLL_DISCOUNT].SECTION_TITLE,
    sectionHint:
      BATCH_TRACK_LABELS[DECISION_TRACKS.PAYROLL_DISCOUNT].SECTION_HINT,
    summaryOf: BATCH_TRACK_LABELS[DECISION_TRACKS.PAYROLL_DISCOUNT].SUMMARY,
    requiresIdentity: true,
    requiresInstallments: true,
  },
  [DECISION_TRACKS.ACCOUNTED_LOSS]: {
    sectionTitle:
      BATCH_TRACK_LABELS[DECISION_TRACKS.ACCOUNTED_LOSS].SECTION_TITLE,
    sectionHint:
      BATCH_TRACK_LABELS[DECISION_TRACKS.ACCOUNTED_LOSS].SECTION_HINT,
    summaryOf: BATCH_TRACK_LABELS[DECISION_TRACKS.ACCOUNTED_LOSS].SUMMARY,
    requiresIdentity: false,
    requiresInstallments: false,
  },
  [DECISION_TRACKS.LOSS_WITHDRAWN]: {
    sectionTitle:
      BATCH_TRACK_LABELS[DECISION_TRACKS.LOSS_WITHDRAWN].SECTION_TITLE,
    sectionHint:
      BATCH_TRACK_LABELS[DECISION_TRACKS.LOSS_WITHDRAWN].SECTION_HINT,
    summaryOf: BATCH_TRACK_LABELS[DECISION_TRACKS.LOSS_WITHDRAWN].SUMMARY,
    requiresIdentity: false,
    requiresInstallments: false,
  },
};

export const requiresIdentity = (track: DecisionTrack): boolean =>
  TRACK_SPEC[track].requiresIdentity;

export const requiresInstallments = (track: DecisionTrack): boolean =>
  TRACK_SPEC[track].requiresInstallments;
